import { memoize } from 'lodash';
import { useSyncExternalStore } from 'react';
import { PlatformConfig } from '../../config';
import { getTimeOfDay, TIMES_OF_DAY } from '../../utils/time';

const getTimeOfDayForCoordinates = memoize(getTimeOfDay, (coordinates?: { lat: number; lng: number }) =>
  coordinates ? `${coordinates.lat},${coordinates.lng}` : '',
);

const sessionTimeOfDayListeners = new Set<() => void>();

const subscribeToSessionTimeOfDay = (listener: () => void) => {
  sessionTimeOfDayListeners.add(listener);
  return () => {
    sessionTimeOfDayListeners.delete(listener);
  };
};

const getForcedTimeOfDay = () => {
  const forcedTimeOfDay = new URLSearchParams(window.location.search).get('timeOfDay');
  return PlatformConfig.isLive ? undefined : TIMES_OF_DAY.find((timeOfDay) => timeOfDay === forcedTimeOfDay);
};

export const getSessionTimeOfDay = (coordinates?: { lat: number; lng: number }) =>
  getForcedTimeOfDay() ?? getTimeOfDayForCoordinates(coordinates);

export const refreshSessionTimeOfDay = () => {
  getTimeOfDayForCoordinates.cache.clear?.();
  sessionTimeOfDayListeners.forEach((listener) => listener());
};

export const useSessionTimeOfDay = (coordinates?: { lat: number; lng: number }) =>
  useSyncExternalStore(subscribeToSessionTimeOfDay, () => getSessionTimeOfDay(coordinates));
